/**
 * @fileoverview Width buckets and list keys for the B2B events page.
 * @module pages/b2bEvents/b2bEventsLayout
 */

export const LAPTOP_MIN_WIDTH = 1024;
export const LAPTOP_MAX_WIDTH = 1440;
export const TABLET_MAX_WIDTH = 1023;
export const MEDIUM_MOBILE_MAX_WIDTH = 767;
export const SMALL_MOBILE_MAX_WIDTH = 480;

export const DESCRIPTION_PREVIEW_LENGTH = 50;
export const BACKDROP_SPINNER_SIZE = 60;
export const BACKDROP_SPINNER_THICKNESS = 4;
export const DRAWER_LAYER_OFFSET = 1;

const SEARCH_WIDTH_LAPTOP = "80.2%";
const SEARCH_WIDTH_TABLET = "73%";
const SEARCH_WIDTH_MEDIUM = "90%";
const SEARCH_WIDTH_SMALL = "75%";
const SEARCH_WIDTH_DESKTOP = "86%";

/**
 * Snapshot of the width buckets taken once per render.
 * @param {number} width
 * @returns {Object}
 */
export const readEventsViewportFlags = (width) => ({
  isLaptop: width >= LAPTOP_MIN_WIDTH && width <= LAPTOP_MAX_WIDTH,
  isTablet: width <= TABLET_MAX_WIDTH,
  isMediumMobile: width <= MEDIUM_MOBILE_MAX_WIDTH,
  isSmallMobile: width <= SMALL_MOBILE_MAX_WIDTH,
});

/**
 * Smaller buckets win when widths overlap.
 * @param {Object} flags
 * @returns {string}
 */
export const eventsDeviceName = (flags) => {
  if (flags.isSmallMobile) {
    return "smallMobile";
  }
  if (flags.isMediumMobile) {
    return "mediumMobile";
  }
  if (flags.isLaptop) {
    return "laptop";
  }
  if (flags.isTablet) {
    return "tablet";
  }
  return "desktop";
};

/**
 * @param {string} device
 * @returns {string}
 */
export const eventsSearchBarWidth = (device) => {
  if (device === "laptop") {
    return SEARCH_WIDTH_LAPTOP;
  }
  if (device === "tablet") {
    return SEARCH_WIDTH_TABLET;
  }
  if (device === "mediumMobile") {
    return SEARCH_WIDTH_MEDIUM;
  }
  if (device === "smallMobile") {
    return SEARCH_WIDTH_SMALL;
  }
  return SEARCH_WIDTH_DESKTOP;
};

/**
 * Prefer the event id. Fall back to name and start date when the id is missing.
 * @param {Object} event
 * @returns {string}
 */
export const b2bEventListKey = (event) => {
  if (event._id) {
    return String(event._id);
  }
  return `${event.nombre}-${event.fechaInicioEvento}`;
};
